
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import tk.mallumo.compose.navigation.ArgumentsNavigation



/**
 * @see one.devsbox.www.ui.login.LoginUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LoginUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LoginUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.resources.detail.ResourceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ResourceUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.resources.detail.ResourceUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ResourceUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.ResourceUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.resources.ListingResourcesUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingResourcesUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingResourcesUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.resources.ListingResourcesUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingResourcesUI(args: one.devsbox.www.ui.resources.ArgsListingResource, clearTop: Boolean = false) {
    navigateTo(Node.ListingResourcesUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.users.detail.UserDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserDUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UserDUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.users.detail.UserDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserDUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.UserDUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.users.activity.UsersActivityUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UsersActivityUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UsersActivityUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.users.activity.UsersActivityUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UsersActivityUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.UsersActivityUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.users.ListingUsersUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingUsersUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingUsersUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.users.edit.UserEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserEUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UserEUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.users.edit.UserEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UserEUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.UserEUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.devices.detail.DeviceDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceDUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DeviceDUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.devices.detail.DeviceDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceDUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.DeviceDUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.devices.ListingDevicesUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingDevicesUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingDevicesUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.devices.edit.DeviceEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceEUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.DeviceEUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.devices.edit.DeviceEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_DeviceEUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.DeviceEUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.campaigns.detail.CampaignDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignDUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CampaignDUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.campaigns.detail.CampaignDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignDUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.CampaignDUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.campaigns.ListingCampaignsUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingCampaignsUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingCampaignsUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.campaigns.edit.CampaignEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignEUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CampaignEUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.campaigns.edit.CampaignEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CampaignEUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.CampaignEUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.company.ListingCompanyUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingCompanyUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingCompanyUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.home.HomeUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_HomeUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.HomeUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.widgets.EmptyUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_EmptyUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.EmptyUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.locations.detail.LocationDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationDUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LocationDUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.locations.detail.LocationDUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationDUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.LocationDUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.locations.ListingLocationUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_ListingLocationUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.ListingLocationUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.locations.edit.LocationEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationEUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.LocationEUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.locations.edit.LocationEUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_LocationEUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.LocationEUI, args.asBundle(), clearTop)
}


/**
 * @see one.devsbox.www.ui.uploader.UploaderUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_UploaderUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.UploaderUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.cmd.CmdUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CmdUI(args: ArgumentsNavigation = ArgumentsNavigation(), clearTop: Boolean = false) {
    navigateTo(Node.CmdUI, args, clearTop)
}


/**
 * @see one.devsbox.www.ui.cmd.CmdUI
 */
@ExtNavMarker
@Suppress("FunctionName")
fun Navigation.navTo_CmdUI(args: one.devsbox.www.tools.ArgsId, clearTop: Boolean = false) {
    navigateTo(Node.CmdUI, args.asBundle(), clearTop)
}

